import { datadogRum } from '@datadog/browser-rum';
import { hashUserLogin } from '../identity';
import { isRumActive, logger } from './state';
import type { RumIdentity } from './types';

/**
 * Attributes RUM data to the signed-in user and account, per {@link RumIdentity}.
 * No-op when RUM is not active.
 */
export function setRumUser({ accountId, userLogin }: RumIdentity): void {
  if (!isRumActive()) {
    return;
  }

  const userId = hashUserLogin(userLogin);

  try {
    if (userId) {
      datadogRum.setUser({ id: userId });
    } else {
      datadogRum.clearUser();
    }

    if (accountId) {
      datadogRum.setAccount({ id: accountId });
    } else {
      datadogRum.clearAccount();
    }

    logger.log('Set RUM user/account', { userId, accountId });
  } catch (err) {
    logger.warn('Failed to set RUM user/account', { userId, accountId }, err);
  }
}
